import {useEffect, useState, useCallback} from 'react';
import getRoomListings from '../services/getRoomListings';

export default function useCityListings(cityId, cityName) {
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  useEffect(() => {
    let current = true;
    setIsLoading(true);
    setError('');
    // Callers supply canonical master-data names, never translated UI labels.
    const params = cityId ? {city_id: Number(cityId)} : {};
    params.city = cityName || 'Riyadh';
    getRoomListings(params).then(response => {
      if (!current) return;
      const data = response?.data;
      setListings(Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []);
    }).catch(() => {
      if (!current) return;
      setListings([]);
      setError('Failed to load listings.');
    }).finally(() => {
      if (current) setIsLoading(false);
    });
    // A slower response for the previous city must not replace the current city.
    return () => {current = false;};
  }, [cityId, cityName, attempt]);
  return {listings, isLoading, error, retry};
}
